import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../src/environments/environment'


@Injectable({
  providedIn: 'root'
})
export class SessionsService {

  private uri = `${environment.apiUrl}`
  private controller = `/public-coach-actions/get-sessions`
  private controller_byId = `/public-coach-actions/get-session`
  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('auth-token'),
    }),
  }

  getAll(): Observable<any> {
    return this.http.get(this.uri + this.controller, this.httpOptions)
  }

  getSessionById(id: number) {
    return this.http.get(this.uri + this.controller_byId + '/' + id, this.httpOptions)
  }

}
